module.exports = __webpack_public_path__ + "img/08.16e7dcd4.webp";